<template>
    <div class="dev-list">
        <div class="dev-list-search">
            <div class="search-btn">
                <el-date-picker
                        v-model="dateValue"
                        type="datetimerange"
                        size="small"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="getLogListForSearch"
                        align="right">
                </el-date-picker>
                <el-button type="primary" @click="handleDownload" :loading="downloadLoading" icon="el-icon-download"
                           size="small" style="margin-left: 40px;">
                    导出Excel
                </el-button>
                <div @keyup.enter="getLogListForSearch" style="position:absolute;right: 30px;">
                    <el-input size="small" placeholder="输入用户名/用户操作 搜索" v-model="searchInfo.queryParam"
                              style="width: 320px">
                        <el-button slot="append" icon="el-icon-search" @click="getLogListForSearch"></el-button>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="device-case-dev border-all">
            <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini" @row-click="checkRow"
                      tooltip-effect="dark" style="width: 99%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" header-align="center"></el-table-column>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="username" label="用户名" min-width="80px"></el-table-column>
                <el-table-column prop="remark" label="操作内容" min-width="150px"></el-table-column>
                <el-table-column label="操作时间">
                    <template slot-scope="scope">
                        {{scope.row.updateTime | formatDateTime}}
                    </template>
                </el-table-column>
                <el-table-column min-width="80px" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="logDelete(scope.row.id)"
                                   v-if="$store.getters.checkChangeAuth()">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn">
                    <!--<el-button size="small" :disabled="multipleSelection.length === 0" plain @click="deleteCaseBatch">删除</el-button>-->
                </div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
        </div>
    </div>

</template>

<script>
    import { commonData, logCommonData } from '@/mixin.js'

    export default {
        name: "LogOperation",
        data() {
            return {
                searchInfo: {
                    usernameLike: "",
                    remarkLike: "",
                    updateTimeFrom: "",
                    updateTimeTo: "",
                    queryParam: ""
                }
            }
        },
        mixins: [commonData,logCommonData],
        methods: {
            // 导出excel数据
            handleDownload() {
                let allLogs = []
                this.downloadLoading = true
                if (!this.dateValue) {
                    this.dateValue = []
                }
                this.downloadLoading = true
                if (this.dateValue.length > 0) {
                    this.searchInfo.updateTimeFrom = this.$util.formatDate(this.dateValue[0])
                    this.searchInfo.updateTimeTo = this.$util.formatDate(this.dateValue[1])
                }
                else {
                    this.searchInfo.updateTimeFrom = ""
                    this.searchInfo.updateTimeTo = ""
                }
                this.$post(this.$uri.log.operationLog, {...this.searchInfo}).then(res => {
                    allLogs = res.list
                    if (allLogs.length > 0) {
                        import('@/vendor/Export2Excel').then(excel => {
                            const tHeader = ['用户名', '操作内容', '操作时间'] // 表头
                            const filterVal = ['username', 'remark', 'updateTime'] // 需要导出的项目
                            const list = allLogs // 所有列表数据
                            const data = this.$util.formatJson(filterVal, list)
                            // console.log("data is " + JSON.stringify(data))
                            excel.export_json_to_excel(
                                tHeader,
                                data,
                                '操作日志'
                            )
                        })
                    } else {
                        this.$message('暂无数据可导出')
                    }
                }).finally(() => {
                    this.downloadLoading = false
                })
            },

            /* 获取操作日志列表 */
            getLogList() {
                if (!this.dateValue) {
                    this.dateValue = []
                }
                if (this.dateValue.length > 0) {
                    this.searchInfo.updateTimeFrom = this.$util.formatDate(this.dateValue[0])
                    this.searchInfo.updateTimeTo = this.$util.formatDate(this.dateValue[1])
                }
                else {
                    this.searchInfo.updateTimeFrom = ""
                    this.searchInfo.updateTimeTo = ""
                }
                this.$post(this.$uri.log.operationLog, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                })
            },
            getLogListForSearch() {
                this.page.startPage = 1
                if (!this.dateValue) {
                    this.dateValue = []
                }
                if (this.dateValue.length > 0) {
                    this.searchInfo.updateTimeFrom = this.$util.formatDate(this.dateValue[0])
                    this.searchInfo.updateTimeTo = this.$util.formatDate(this.dateValue[1])
                }
                else {
                    this.searchInfo.updateTimeFrom = ""
                    this.searchInfo.updateTimeTo = ""
                }
                this.$post(this.$uri.log.operationLog, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getLogList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getLogList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            /* 删除设备池 */
            async deleteCase(id) {
                await this.$post(this.$uri.log.operationLogDelete, {id})
            },
            /* 批量删除设备池 */
            deleteCaseBatch() {
                this.$confirm("日志删除后无法恢复，是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-yellow',
                    iconClass: 'el-icon-c-yellow',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.multipleSelection.forEach(v => {
                        this.deleteCase(v.id)
                    })
                    this.$message.success("删除完成")
                    let that = this
                    setTimeout(() => {
                        that.getLogList()
                    }, 1000)
                }).catch(() => {
                })
            },
            /* 删除日志 */
            logDelete(id) {
                this.$confirm("确认删除？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.$post(this.$uri.log.operationLogDelete, {id}).then(() => {
                        this.$message.success("删除成功")
                        this.getLogList()
                    })
                }).catch(() => {
                })
            }
        },
        mounted() {
            this.getLogList()
        },
    };
</script>

<style lang="less" scoped>
    .dev-list {
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .search-main-item {
                        /*width: 31%;*/
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                            margin-right: 6px;
                        }
                        .item-input {
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 0 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
</style>